import React from 'react'
import classnames from 'classnames'

import RadioButton from '../../../../components/radioButton'
import { PaymentMode } from '../../../../core/types'

export interface PaymentMontlyOptionProps {
  isChecked: boolean
  setPaymentOption: (option: PaymentMode) => void
  children: React.ReactNode
}

export function PaymentMontlyOption({
  children,
  isChecked,
  setPaymentOption,
}: PaymentMontlyOptionProps) {
  const handleContainerClick = () => {
    setPaymentOption('monthly')
  }

  return (
    <div
      className={classnames('refi-payment-options__container', {
        'refi-payment-options__container--selected': isChecked,
      })}
      onClick={handleContainerClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="refi-payment-options__title-container">
        <span className="refi-payment-options__title">Pay monthly</span>
        <div className="refi-payment-options__title-left-section">
          <RadioButton
            checked={isChecked}
            name="payment-options"
            value="pay-monthly"
            iconSize="20px"
            uid="pay-monthly-checkbox"
            onChange={() => setPaymentOption('monthly')}
          />
        </div>
      </div>
      {children}
    </div>
  )
}
